import "@/App.css";
import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import ServicePage from "@/pages/ServicePage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import { SERVICES } from "@/seo/content";
import { trackPageview } from "@/lib/analytics";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    // Defer to next tick so Helmet has updated the title
    const id = setTimeout(() => trackPageview(location.pathname + location.search), 50);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-maif">
        <RouteTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          {Object.keys(SERVICES).map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<ServicePage slug={slug} />} />
          ))}
          <Route path="*" element={<LandingPage />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#111114",
              color: "#F2EBE5",
              border: "1px solid rgba(217,185,155,0.18)",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
